/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCustomerFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type Customer, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { AddressRequestBuilderRequestsMetadata, type AddressRequestBuilder } from './address/index.js';
// @ts-ignore
import { AffiliateRequestBuilderRequestsMetadata, type AffiliateRequestBuilder } from './affiliate/index.js';
// @ts-ignore
import { AuditentriesRequestBuilderRequestsMetadata, type AuditentriesRequestBuilder } from './auditentries/index.js';
// @ts-ignore
import { BankAccountRequestBuilderRequestsMetadata, type BankAccountRequestBuilder } from './bankAccount/index.js';
// @ts-ignore
import { BusinessConversionRequestBuilderRequestsMetadata, type BusinessConversionRequestBuilder } from './businessConversion/index.js';
// @ts-ignore
import { CompanyRegistrationRequestBuilderRequestsMetadata, type CompanyRegistrationRequestBuilder } from './companyRegistration/index.js';
// @ts-ignore
import { ConsumerConversionRequestBuilderRequestsMetadata, type ConsumerConversionRequestBuilder } from './consumerConversion/index.js';
// @ts-ignore
import { ConsumptionRequestBuilderNavigationMetadata, type ConsumptionRequestBuilder } from './consumption/index.js';
// @ts-ignore
import { ContactRequestBuilderRequestsMetadata, type ContactRequestBuilder } from './contact/index.js';
// @ts-ignore
import { ContractsRequestBuilderRequestsMetadata, type ContractsRequestBuilder } from './contracts/index.js';
// @ts-ignore
import { DataSharingGrantsRequestBuilderRequestsMetadata, type DataSharingGrantsRequestBuilder } from './dataSharingGrants/index.js';
// @ts-ignore
import { DocumentsRequestBuilderRequestsMetadata, type DocumentsRequestBuilder } from './documents/index.js';
// @ts-ignore
import { MessagesRequestBuilderNavigationMetadata, MessagesRequestBuilderRequestsMetadata, type MessagesRequestBuilder } from './messages/index.js';
// @ts-ignore
import { NotesRequestBuilderRequestsMetadata, type NotesRequestBuilder } from './notes/index.js';
// @ts-ignore
import { OauthconnectionsRequestBuilderRequestsMetadata, type OauthconnectionsRequestBuilder } from './oauthconnections/index.js';
// @ts-ignore
import { TagsRequestBuilderRequestsMetadata, type TagsRequestBuilder } from './tags/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/{customer-id}
 */
export interface CustomerItemRequestBuilder extends BaseRequestBuilder<CustomerItemRequestBuilder> {
    /**
     * The address property
     */
    get address(): AddressRequestBuilder;
    /**
     * The affiliate property
     */
    get affiliate(): AffiliateRequestBuilder;
    /**
     * The auditentries property
     */
    get auditentries(): AuditentriesRequestBuilder;
    /**
     * The bankAccount property
     */
    get bankAccount(): BankAccountRequestBuilder;
    /**
     * The businessConversion property
     */
    get businessConversion(): BusinessConversionRequestBuilder;
    /**
     * The companyRegistration property
     */
    get companyRegistration(): CompanyRegistrationRequestBuilder;
    /**
     * The consumerConversion property
     */
    get consumerConversion(): ConsumerConversionRequestBuilder;
    /**
     * The consumption property
     */
    get consumption(): ConsumptionRequestBuilder;
    /**
     * The contact property
     */
    get contact(): ContactRequestBuilder;
    /**
     * The contracts property
     */
    get contracts(): ContractsRequestBuilder;
    /**
     * The dataSharingGrants property
     */
    get dataSharingGrants(): DataSharingGrantsRequestBuilder;
    /**
     * The documents property
     */
    get documents(): DocumentsRequestBuilder;
    /**
     * The messages property
     */
    get messages(): MessagesRequestBuilder;
    /**
     * The notes property
     */
    get notes(): NotesRequestBuilder;
    /**
     * The oauthconnections property
     */
    get oauthconnections(): OauthconnectionsRequestBuilder;
    /**
     * The tags property
     */
    get tags(): TagsRequestBuilder;
    /**
     * DeleteCustomer
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * GetCustomer
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Customer>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Customer | undefined>;
    /**
     * DeleteCustomer
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * GetCustomer
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CustomerItemRequestBuilderUriTemplate = "{+baseurl}/customers/{customer%2Did}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CustomerItemRequestBuilderNavigationMetadata: Record<Exclude<keyof CustomerItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    address: {
        requestsMetadata: AddressRequestBuilderRequestsMetadata,
    },
    affiliate: {
        requestsMetadata: AffiliateRequestBuilderRequestsMetadata,
    },
    auditentries: {
        requestsMetadata: AuditentriesRequestBuilderRequestsMetadata,
    },
    bankAccount: {
        requestsMetadata: BankAccountRequestBuilderRequestsMetadata,
    },
    businessConversion: {
        requestsMetadata: BusinessConversionRequestBuilderRequestsMetadata,
    },
    companyRegistration: {
        requestsMetadata: CompanyRegistrationRequestBuilderRequestsMetadata,
    },
    consumerConversion: {
        requestsMetadata: ConsumerConversionRequestBuilderRequestsMetadata,
    },
    consumption: {
        navigationMetadata: ConsumptionRequestBuilderNavigationMetadata,
    },
    contact: {
        requestsMetadata: ContactRequestBuilderRequestsMetadata,
    },
    contracts: {
        requestsMetadata: ContractsRequestBuilderRequestsMetadata,
    },
    dataSharingGrants: {
        requestsMetadata: DataSharingGrantsRequestBuilderRequestsMetadata,
    },
    documents: {
        requestsMetadata: DocumentsRequestBuilderRequestsMetadata,
    },
    messages: {
        requestsMetadata: MessagesRequestBuilderRequestsMetadata,
        navigationMetadata: MessagesRequestBuilderNavigationMetadata,
    },
    notes: {
        requestsMetadata: NotesRequestBuilderRequestsMetadata,
    },
    oauthconnections: {
        requestsMetadata: OauthconnectionsRequestBuilderRequestsMetadata,
    },
    tags: {
        requestsMetadata: TagsRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CustomerItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: CustomerItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: CustomerItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCustomerFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
